import { isValidQueryValue } from '@asset/function/queryStringFunctions';
import { QueryStoreKey } from '@asset/enum/queryStoreKey';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { RouterQueryRecord } from '@asset/type/common/query';

interface QueryParamsState {
  queryParamsData: Partial<Record<QueryStoreKey, RouterQueryRecord>>;
  setQueryParams: (storeKey: QueryStoreKey, params: RouterQueryRecord) => void;
  resetQueryParams: () => void;
}

export const useQueryParamsStore = create(
  persist<QueryParamsState>(
    (set) => ({
      queryParamsData: {},

      setQueryParams: (storeKey, params) => {
        if (!storeKey || !params) {
          console.error('both storeKey and params are required');
          return;
        }

        set((state) => {
          const newStoreQueryData: RouterQueryRecord = Object.fromEntries(
            Object.entries(params).filter(
              ([queryKey, value]) => queryKey && isValidQueryValue(value),
            ),
          );

          const newTotalQueryData = Object.fromEntries(
            Object.entries({
              ...state.queryParamsData,
              [storeKey]: newStoreQueryData,
            }).filter(([, value]) => Object.keys(value).length > 0),
          );

          return {
            queryParamsData: newTotalQueryData,
          };
        });
      },

      resetQueryParams: () => {
        set({ queryParamsData: {} });
      },
    }),
    {
      name: 'persisted-query-params',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
